export const transactionPaymentTypes = {
  scanner: 'SCANNER',
  cash: 'CASH',
  creditCard: 'CARD',
}

export const PAYMENT_TYPES = {
  scanner: 'Terminal',
  creditCard: 'Manual Credit Card',
}

const paymentErrorMessage = 'Payment unsuccessful. Payment was not captured. Please try again'
 
export const defaultPaymentErrorMessage = (message?: string) =>
  message ? `${paymentErrorMessage}. Reason: ${message}` : paymentErrorMessage